import type { RootLocationFeatureToggles } from '@infield/features/app-config';

export const getIsOverviewPageEnabled = (
  rootLocationFeatureToggles:
    | RootLocationFeatureToggles
    | Record<string, boolean>
    | undefined
) =>
  Boolean(
    rootLocationFeatureToggles?.templateChecklistFlow ||
      rootLocationFeatureToggles?.workorderChecklistFlow
  );
export const getIsChecklistPageEnabled = (
  rootLocationFeatureToggles:
    | RootLocationFeatureToggles
    | Record<string, boolean>
    | undefined
) =>
  Boolean(
    rootLocationFeatureToggles?.templateChecklistFlow ||
      rootLocationFeatureToggles?.workorderChecklistFlow
  );

export const getIsTemplatesPageEnabled = (
  rootLocationFeatureToggles:
    | RootLocationFeatureToggles
    | Record<string, boolean>
    | undefined
) => Boolean(rootLocationFeatureToggles?.templateChecklistFlow);

export const getIsObservationsPageEnabled = (
  rootLocationFeatureToggles:
    | RootLocationFeatureToggles
    | Record<string, boolean>
    | undefined
) =>
  Boolean(
    typeof rootLocationFeatureToggles?.observations !== 'boolean' &&
      rootLocationFeatureToggles?.observations?.isEnabled
  );

export const getRootContainer = () => document.getElementById('root');
